import styled from "styled-components";

import { typographyWeights } from "../constants/fontWeightOptions";
import { baseTextStyles } from "../shared/styled";

export const SecondaryLargeBase = styled.h4`
  ${baseTextStyles}
  font-size: 22px;
  font-weight: ${props => typographyWeights[props.weight]};
  line-height: 32px;
`;
